import Dashboard from "../../views/dashboard/Dashboard.vue";

const errorcodemanagement = {
  path: "/errorcodemanagement",
  name: "errorcodemanagement",
  redirect: "errorcodeinfo",
  component: Dashboard,
  meta: {
    title: "异常上报",
    icon: "el-icon-s-cooperation",
    role: false
  },
  children: [
    {
      path: "/ecode",
      name: "ecode",
      component: () =>
        import("../../components/errorcode/errorcode.vue"),
      meta: {
        title: "故障代码",
        icon: "el-icon-warning-outline",
        role: false
      }
    },
    {
      path: "/adminecode",
      name: "adminecode",
      component: () =>
        import("../../components/errorcode/adminErrorcode.vue"),
      meta: {
        title: "故障代码管理",
        icon: "el-icon-warning-outline",
        role: false
      }
    },

    {
      path: "/erecord",
      name: "erecord",
      component: () =>
        import("../../components/errorcode/errorRecord.vue"),
      meta: {
        title: "故障记录",
        icon: "el-icon-document-delete",
        role: false
      }
    },
    {
      path: "/adminrecord",
      name: "adminrecord",
      component: () =>
        import("../../components/errorcode/adminErrorRecord.vue"),
      meta: {
        title: "故障记录管理",
        icon: "el-icon-document-delete",
        role: false
      }
    },


  ]
};

export default errorcodemanagement;
